import { FormGroup, Input } from 'reactstrap';
import { InputOverrideType, MandatoryInputMap } from '../types';

export interface MandatoryProps {
  mandatory: MandatoryInputMap;
  columnCode: string;
  onToggleSwitch: (props: { type: InputOverrideType; code: string }) => void;
}

export const MandatoryForm = ({ mandatory, columnCode, onToggleSwitch }: MandatoryProps) => {
  const { isEnforced, isLockedByUtr } = mandatory[columnCode];

  return (
    <div className='row gx-0 mb-3'>
      <FormGroup switch className='col-12 d-flex align-items-center' id={`mandatory-${columnCode}`}>
        <Input
          type='switch'
          className='mr-2'
          onChange={() => onToggleSwitch({ type: InputOverrideType.Mandatory, code: columnCode })}
          checked={isEnforced}
          disabled={isLockedByUtr}
        />
        <label htmlFor={`mandatory-${columnCode}`} className={isLockedByUtr ? 'text-ThemeTextMedium' : ''}>
          Input mandatory for submission
        </label>
        {isLockedByUtr ? (
          <span className='text-ThemeTextLight ml-2 text-sm'>(Set by sustainability team)</span>
        ) : null}
      </FormGroup>
      <div className='text-ThemeTextMedium text-sm pl-3'>
        An answer is required for this input for the metric to be successfully submitted. If this input is left empty, the user will be unable to submit the metric.
      </div>
    </div>
  );
};

